import { gaEvent } from '../common/services/analytics'
import { deleteItem } from '../common/services/api'
import * as DataOperations from './Data'

export function deleteShift(id) {
  return (dispatch) => {
    return deleteItem(id, 'shifts')
      .then(() => {
        dispatch(DataOperations.loadList('shifts'))
        gaEvent({
          category: 'Forms',
          action: `Deleted shift`
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }
}
